// extracted by mini-css-extract-plugin
export default {"Tabs":"Tabs_Tabs__rQGjG","nav":"Tabs_nav__TKWfr","active":"Tabs_active__uGUKx","tabContentHidden":"Tabs_tabContentHidden__3H+ha"};